import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { EntityLinkService } from '../entity-link.service'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { EntityServiceLink } from '../entity-service-link'
import { NgTemplateOutlet } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu'
import { MatIconButton } from '@angular/material/button'

@Component({
  selector: 'app-entity-link',
  templateUrl: './entity-link.component.html',
  styleUrls: ['./entity-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu, NgTemplateOutlet, MatMenuItem],
})
export class EntityLinkComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger('EntityLinkComponent')
  private _ignoreServices: string[] = []
  private entityLinkService = inject(EntityLinkService)

  /**
   * The entities' id.
   */
  @Input()
  public entityId: string

  /**
   * The entities' type.
   */
  @Input({ required: true })
  public entityType: string

  /**
   * The entities' company.
   */
  @Input()
  public company: string

  public serviceLinks: EntityServiceLink[]

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    if (!this.entityType) {
      throw new Error('Entity Type not set! To use EntityLinkComponent a type must be specified!')
    }

    this.entityLinkService
      .getLinksForEntity(this.entityType, this.entityId, this.company)
      .subscribe({
        next: (serviceLinks) =>
          (this.serviceLinks = serviceLinks.filter(
            (serviceLink) => !this._ignoreServices.includes(serviceLink.service)
          )),
        error: (err) =>
          this.log.error('Failed to load service links for entity ' + this.entityId, err),
      })
  }
  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  /**
   * Services which should not get displayed.
   * Useful for hiding service of current context.
   */
  @Input()
  public set ignoreServices(ignoreServices: string) {
    this._ignoreServices = ignoreServices ? ignoreServices.split(',') : []
  }
}
